import script from "./QuantityBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./QuantityBlock.vue?vue&type=script&setup=true&lang=js"

import "./QuantityBlock.vue?vue&type=style&index=0&id=ac53474c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac53474c"]])

export default __exports__